import React, { useEffect, useState } from 'react'
import useAuth from '../../hooks/useAuth';
import useProcesoMatricula from '../../hooks/useProcesoMatricula';
import { obtenerLabelEtiqueta } from '../../utils/idioma/LabelsIdioma';

export default function ModalCruceHorario() {

  const {listadoEtiquetas } = useAuth();
  const [etiquetas, setEtiquetas] = useState({});
  let {
     msgModalHorario
  } = useProcesoMatricula();

  useEffect(() => {
    
    if (listadoEtiquetas.length > 0) {
      setEtiquetas({
      
        lbl_update_datos_continuar: obtenerLabelEtiqueta(
          "lbl_update_datos_continuar",
          listadoEtiquetas
        )
      });
    }
  }, [listadoEtiquetas]);
  const {lbl_update_datos_continuar} = etiquetas;
  const {title,text}= msgModalHorario;

  return (
    <div className="modal fade" id="cruce" tabIndex="-1" data-bs-backdrop="static" aria-labelledby="exampleModalLabelcruce" aria-hidden="true">
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content">
        <div className="modal-header border-bottom-0 pb-0">
          <h5 className="modal-title" id="exampleModalLabelcruce"></h5>
          <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div className="modal-body pb-0 pt-0">
            <div className="text-center">
              <div className=" va-middle add-cart">
                <div className="icon-pendiente warning animate__animated animate__wobble animate-warning "> 
                  <span className="body "></span> 
                  <span className="dot "></span> 
                </div> 
                    

            </div>
                <h5 className="text-uppercase ">{title}</h5>
                  <p>{text}.</p>
              
            </div>
        </div>
        
        <div className="modal-footer">
          
          <button type="button" className="btn btn-primary"  data-bs-dismiss="modal"
            aria-label="Close">{lbl_update_datos_continuar}</button>
        </div>
      </div>
    </div>
  </div>

  )
}
